import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for the Track Shipment.

Referenced by the page.track-shipment.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, createClient } from 'urql';
import Tracking from './components/Tracking';
import { JSON_HEADERS } from './config/constants';
import { OV_GRAPHQL_URL } from './config/theme';
import './scss/templates/page-track-shipment.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var urlParams = new URLSearchParams(window.location.search);
var cartonId = urlParams.get('carton_id');
var token = urlParams.get('token');
var client = createClient({
  url: OV_GRAPHQL_URL
});

var throw404 = function throw404() {
  window.location.assign('/404');
};

var KILL_SWITCH = 429; // backend signalling excessive requests, display delay messaging

var NoDetailsMessage = function NoDetailsMessage() {
  var noDetailsStyle = {
    margin: '72px auto 0',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  };
  return /*#__PURE__*/_jsxs("h3", {
    style: noDetailsStyle,
    children: ["We\u2019re working to get your package shipped!", /*#__PURE__*/_jsx("br", {}), "Check back soon for more shipping details."]
  });
};
/**
 * Initialize the root React component
 * @param {Object} The API object
 */


var init = function init(tracker, noDetails) {
  if (tracker === undefined) {
    return;
  }

  var trackers = tracker ? [_objectSpread({}, tracker)] : [];
  ReactDOM.render( /*#__PURE__*/_jsxs(Provider, {
    value: client,
    children: [noDetails && /*#__PURE__*/_jsx(NoDetailsMessage, {}), !noDetails && /*#__PURE__*/_jsx(Tracking, {
      loading: false,
      trackers: trackers
    })]
  }), document.getElementById('track-shipment'));
};

var load = function load() {
  var NS_ENDPOINT = window.OV.NS_ENDPOINT;
  init(false); // initial render

  if (token.indexOf('?') > -1) {
    token = token.split('?')[0]; // eslint-disable-line prefer-destructuring

    urlParams.set('token', token);
  }

  var statusHasKillSwitch = false;
  fetch("".concat(NS_ENDPOINT, "fulfillments/").concat(cartonId, "/?token=").concat(token), JSON_HEADERS).then(function (response) {
    statusHasKillSwitch = response.status === KILL_SWITCH;
    return response.json();
  }).then(function (json) {
    init(json, statusHasKillSwitch);
  });
};

if (cartonId === null || token === null) {
  throw404();
} else {
  load();
}